module.exports = __webpack_public_path__ + "img/save-white.fe8698b7.svg";